var favourite_content_resource = (function ($) {
    var _init = function () {
        $(document).on("click", ".favourite-button", handle_favourite_click);
    };

    var handle_favourite_click = function (event) {
        event.preventDefault();

        var content_resource_id = $(this).data('content-resource-id');
        var is_favourited = $(this).data('toggle'); // Toggle state (0 or 1)

        var new_toggle_state = is_favourited ? 0 : 1;

        toggle_favourite_resource(new_toggle_state, content_resource_id);

        $(this).data('toggle', new_toggle_state);

        update_button_appearance($(this), new_toggle_state);
    };

    var toggle_favourite_resource = function (toggle, content_resource_id) {
        let data = {
            nonce: scriptData.vibe_eos_favouriteContentResource_ajax_favourite_nonce,
            action: 'vibe_eos_favouriteContentResource_ajax_favourite',
            toggle: toggle ? 1 : 0,
            content_resource_id: content_resource_id
        }

        $.post(scriptData.ajaxURL, data, function (res) {
            if (res.success) {
                console.log('Successfully toggled favourited ' + res.toggle);
            } else {
                console.log('Error: ' + res.message);
            }
        });
    }

    var update_button_appearance = function (button, toggle_state) {
        if (toggle_state === 1) {
            button.addClass('favourited');
        } else {
            button.removeClass('favourited');
        }
    }

    $(document).ready(_init);

    return {};

})(jQuery);

module.exports = favourite_content_resource;